import { ICreateObraInformacoesUseCase } from "../../../presentation/useCases/create/create_obra_informacoes_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateInformacaoObraUseCase
 */

export class CreateObraInformacoesUseCase implements ICreateObraInformacoesUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createObraInformacoes(
    idObra: number,
    idFuncionario: number,
    data: Date,
    descInformacoes: string,
  ): Promise<void> {
    await this.repository.createObraInformacoes(
      idObra,
      idFuncionario,
      data,
      descInformacoes,
    );
  }
}
